import { AfterViewChecked, Component, ElementRef, Input, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-c-checkbox',
  templateUrl: './c-checkbox.component.html',
  styleUrls: ['./c-checkbox.component.scss']
})
export class CCheckboxComponent implements AfterViewChecked {
  @Input() control = new FormControl<boolean>(false);

  @Input() label!: string | number | undefined;

  @Input() id!: string | number;

  @Input() controlDisabled: boolean = false;

  @Input() indeterminate: boolean = false;

  @Input() contractNumberInput = false;

  _checked: boolean | undefined = false;

  @Input()
  set checked(val) {
    this._checked = val;
    this.control.patchValue(this.checked ?? false);
  }

  get checked() {
    return this._checked;
  }

  _disabled: boolean | undefined = false;

  @Input()
  public set disabled(val) {
    this._disabled = val;
    this._disabled ? this.control.disable() : this.control.enable();
  }

  public get disabled() {
    return this._disabled;
  }

  @ViewChild('nativeInput') nativeInput?: ElementRef<HTMLInputElement>;

  constructor() { }

  ngAfterViewChecked(): void {
    // Re-assert the native indeterminate state every change detection cycle.
    // A user click clears it in the DOM, but Angular won't restore it when the
    // bound value stays the same (e.g. selection remains partial).
    if (this.nativeInput) {
      this.nativeInput.nativeElement.indeterminate = this.indeterminate;
    }
  }
}
